import Vue from 'vue';
import mixins from 'vue-typed-mixins';

import { E有無フラグ } from '@/openapi/enum';
import { 勘定科目Api, 勘定科目ListItemResponse } from '@/openapi/user';

import UserApiUtility from '@/classes/common/UserApiUtility';
import EventObserverMixin from '@/mixins/EventObserverMixin';

type State = {
  is科目別損益計算表: boolean;
};

const state = Vue.observable<State>({
  is科目別損益計算表: false,
});

export default mixins(EventObserverMixin).extend({
  name: 'M計画損益計算表Mixin',

  computed: {
    is科目別損益計算表(): boolean {
      return state.is科目別損益計算表;
    },
  },

  methods: {
    inactivate科目別損益計算表(): void {
      state.is科目別損益計算表 = false;
    },
    toggle科目別損益計算表(): void {
      state.is科目別損益計算表 = !state.is科目別損益計算表;
    },
    async show科目別計画(listItem: 勘定科目ListItemResponse): Promise<void> {
      if (listItem.c科目別計画フラグ === E有無フラグ.なし) {
        await UserApiUtility.ogApi(勘定科目Api).activate勘定科目科目別計画フラグ(listItem.pk);
        this.publishEvent(); // API再読み込みを促す
      }
      this.toggle科目別損益計算表();
    },
  },
});
